import styled from 'styled-components/macro';
import { media, space } from '../../../theme/tokens';

export const ChatContainer = styled.section`
  min-height: 100%;
  width: 100%;
`;

// space between the messages and the fixed bars above and below them
const edgeGap = space[4];

export const ChatMessagesList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
  background: ${({ theme }) => theme.chatBackground};
  list-style: none;
  padding: ${space[2]};
  /* clear the fixed Whiteboard bar and the fixed 8rem MessageForm, with a gap at each end */
  padding-top: calc(
    ${({ whiteboardHeight }) => whiteboardHeight}px + ${edgeGap}
  );
  padding-bottom: calc(8rem + ${edgeGap});
  margin: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  /* the heights below assume padding is added on top of min-height, so opt out
     of the app-wide border-box sizing (otherwise a gap appears above the form) */
  box-sizing: content-box;
  /* fullscreen - MessageForm - WhiteBoard - Nav */
  min-height: calc(
    100vh - 8rem - ${({ whiteboardHeight }) => whiteboardHeight}px -
      (2 * ${edgeGap}) - 8.5vh
  );

  ${media.sm`
    padding-left: ${space[4]};
    padding-right: ${space[4]};
  `}

  ${media.md`
    padding-left: ${space[5]};
    padding-right: ${space[5]};
    /* fullscreen - MessageForm - WhiteBoard */
    min-height: calc(
      100vh - 8rem - ${({ whiteboardHeight }) => whiteboardHeight}px -
        (2 * ${edgeGap})
    );
  `}
`;
